import { httpInstance } from '../../api'
import * as types from '../mutation-types'

function getMenu (navMenu) {
  let menuItems = []
  if (navMenu.length > 0) {
    navMenu.forEach(element => {
      if (element.name === 'Reports') {
        menuItems.push({divider: true})
        menuItems.push({header: 'Reports'})
      } else if (element.name === 'Master Data') {
        menuItems.push({divider: true})
        menuItems.push({header: 'Master Data'})
      } else if (element.name === 'System Administration') {
        menuItems.push({divider: true})
        menuItems.push({header: 'System Administration'})
      }
      element.menu_subs.forEach(sub => {
        let row = {}
        row.icon = sub.icon
        row.title = sub.title
        row.to = sub.to
        row.id = sub.id
        menuItems.push(row)
      })
    })
  }
  return menuItems
}

const state = {
  nav_menu_items: [],
  menu_list_options: []
}

const getters = {
  getMenuForDrawer: state => {
    return getMenu(state.nav_menu_items)
  },

  getAllowedMenuItems: (state) => {
    let menu = []
    let menuItems = getMenu(state.menu_list_options)
    menuItems.forEach(sub => {
      if (sub.id !== 1 && sub.id !== 10) {
        menu.push(sub)
      }
    })
    return menu
  },

  getAllowedMenuPath: state => {
    let allMenu = getMenu(state.nav_menu_items)
    let menuPath = []
    allMenu.forEach(menu => {
      if (menu.id) {
        menuPath.push(menu.to)
      }
    })
    return menuPath
  }
}

const mutations = {
  [types.GET_ALL_MENU_ITEMS] (state, payload) {
    payload.forEach(sub => {
      sub.menu_subs.sort((x, y) => {
        return x.id - y.id
      })
    })
    payload.sort((a, b) => {
      return a.id - b.id
    })
    state.nav_menu_items = payload
  },

  [types.GET_MENU_LIST_OPTIONS] (state, payload) {
    payload.sort((a, b) => {
      return a.id - b.id
    })
    state.menu_list_options = payload
  }
}

const actions = {
  async fetchMenuItems ({commit}) {
    commit(types.SET_LOADING, true)
    await httpInstance.get(`menu/list`).then(response => {
      commit(types.GET_MENU_LIST_OPTIONS, response.data)
      commit(types.SET_LOADING, false)
    }).catch(error => {
      commit(types.SET_LOADING, false)
      console.log(error.response)
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js